import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Layout from '../../componentsv2/Layout';
import Skeleton from '../../componentsv2/Skeleton';

export default function FactoringCreditLineSkeleton() {
  return (
    <Layout>
      <Grid container rowSpacing={2}>
        {/* Header */}
        <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Skeleton width="60%" height="36px" />
          <Skeleton width="40%" height="21px" />
        </Grid>

        {/* Tabs */}
        <Grid item xs={12}>
          <Skeleton width="30%" height="36px" />
        </Grid>

        {/* Content */}
        <Grid item xs={12}>
          <Box
            sx={{
              background: '#fff',
              borderRadius: '12px',
              p: 3,
              gap: '1em',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Skeleton width="30%" height="36px" />
            <Skeleton width="100%" height={400} />
          </Box>
        </Grid>
      </Grid>
    </Layout>
  );
}
